module.exports = __webpack_public_path__ + "img/anbgnew.97a22b91.jpg";